import { ArrowRight, ArrowLeft } from "lucide-react";

const PAGE_SIZE_OPTIONS = [ 5,10, 20, 50, 100 ];

const PaginationControl = ( {
    currentPage,
    totalPages,
    onPageChange,
    pageSize = 10,
    hasPreviousPage,
    hasNextPage,
    onPageSizeChange,
} ) => {
    const handlePrevious = () => {
        if ( currentPage > 1 ) {
            onPageChange( Number( currentPage ) - 1 );
        }
    };

    const handleNext = () => {
        if ( currentPage < totalPages ) {
            onPageChange( Number( currentPage ) + 1 );
        }
    };

    const handlePageSizeChange = ( e ) => {
        onPageSizeChange( Number( e.target.value ) );
    };

    return (
        <div className="flex justify-between md:justify-center md:justify-end items-center space-x-2 md:space-x-4 mt-4">
            <div className="flex items-center space-x-2">
                <span>Rows:</span>
                <select
                    value={pageSize}
                    onChange={handlePageSizeChange}
                    className="px-2 py-1 rounded border border-gray-300 bg-white"
                >
                    {PAGE_SIZE_OPTIONS.map( ( size ) => (
                        <option key={size} value={size}>{size}</option>
                    ) )}
                </select>
            </div>
            <div className="flex items-center space-x-2">
            <button
                onClick={handlePrevious}
                disabled={!hasPreviousPage}
                className={`px-4 py-2 rounded ${!hasPreviousPage ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 text-white hover:bg-secondary-500'}`}
            >
                <span className="hidden md:inline-block">Previous</span>
                <span className="md:hidden"><ArrowLeft /></span>
            </button>
            <span className="hidden md:inline-block">Page {currentPage} of {totalPages}</span>
            <span className="md:hidden">{currentPage}/{totalPages}</span>
            <button
                onClick={handleNext}
                disabled={!hasNextPage}
                className={`px-4 py-2 rounded ${!hasNextPage ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 text-white hover:bg-secondary-500'}`}
            >
                <span className="hidden md:inline-block">Next</span>
                <span className="md:hidden"><ArrowRight /></span>

                </button>
                </div>
        </div>
    );
};

export default PaginationControl;
